module.exports = __webpack_public_path__ + "img/dolla.577c402d.png";